// extracted by mini-css-extract-plugin
export default {"items":"ItemsGrid_items__FPU4i","item":"ItemsGrid_item__ZF7JD"};